import { z } from 'zod'

/** Every non-2xx response from the API uses this envelope. */
export const apiErrorSchema = z.object({
  error: z.object({
    /** Stable, machine-readable code. Widen the union as endpoints are added. */
    code: z.string(),
    /** Human-readable message. Safe to surface in the UI. */
    message: z.string(),
    /** Field-level details, e.g. from a failed request-body validation. */
    details: z.unknown().optional(),
  }),
})

export type ApiError = z.infer<typeof apiErrorSchema>
